/* eslint-disable */
import { formatLocaleDate, formatLocaleTime } from './formatLocaleDate';

export default class AssessmentHelper {
  static evaluateStatus(taskElement) {
    const checkSameDay = (date1, date2) => {
      if (date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate()) return true;
      return false;
    };

    let dateToShow = '';
    let dateHeadline = '';
    let status = 'inactive';

    const taskBegin = new Date(Date.parse(taskElement.date_taskBegin));
    const taskEnd = new Date(Date.parse(taskElement.date_taskEnd));

    let showDate_Begin = formatLocaleDate(taskBegin);
    const showTime_Begin = formatLocaleTime(taskBegin);

    let showDate_End = formatLocaleDate(taskEnd);
    const showTime_End = formatLocaleTime(taskEnd);

    if (checkSameDay(new Date(), taskBegin)) showDate_Begin = '';
    else showDate_Begin += '/';

    if (checkSameDay(new Date(), taskEnd)) showDate_End = '';
    else showDate_End += '/';

    const beginString = String(showDate_Begin) + String(showTime_Begin);
    const endString = String(showDate_End) + String(showTime_End);

    switch (taskElement.status) {
      case 'scheduled':
        status = 'inactive';
        dateHeadline = 'taskBeginsAt';
        dateToShow = beginString;
        break;
      case 'open':
        status = 'active';
        dateHeadline = 'taskDoUntil';
        dateToShow = endString;
        break;
      case 'began':
        status = 'active';
        dateHeadline = 'taskDoUntil';
        dateToShow = endString;
        break;
      case 'submitted':
        status = 'inactive';
        dateHeadline = 'empty';
        dateToShow = 'submitted';
        break;
      case 'expired':
        status = 'inactive';
        dateHeadline = 'taskExpired';
        dateToShow = endString;
        break;
      case 'canceled':
        status = 'inactive';
        dateHeadline = '';
        dateToShow = 'canceled';
        break;
    }

    return {
      status,
      dateToShow,
      dateHeadline,
    };
  }

  /** Intro page is shown only when enabled and title, body, and button exist for the locale. */
  static hasRenderableIntro(assessment, locale) {
    const intro = assessment?.config?.intro;
    if (!intro?.enabled) return false;
    const lang = locale || 'en';
    return !!(intro.title?.[lang]?.trim()
      && intro.content?.[lang]?.trim()
      && intro.buttonText?.[lang]?.trim());
  }

  /** Assessment-Typ values already assigned to a schema (FA-02.08: results grouped by type). */
  static usedSchemaTypes(schemas) {
    return new Set(
      (schemas || [])
        .map((schema) => schema?.type)
        .filter((type) => typeof type === 'string' && type.trim())
        .map((type) => type.trim()),
    );
  }

  static isSchemaTypeInUse(type, schemas) {
    if (!type || typeof type !== 'string') return false;
    return AssessmentHelper.usedSchemaTypes(schemas).has(type.trim());
  }
}
